import {
  TArrayToPronounHandledGenders,
  TArrayToSentenceConfig,
} from "./types/string-utils.types";

/** Joins the given array of words,
 * using the lastSeparator to link the last word with the rest and the
 * separator to join all other words.
 * Here are some examples using the default separator values.
 * Given the array ["w","x","y","z"] returns the string "w, x, y and z".
 * Given the array ["x","y"] returns the string "x and y".
 * Given the array ["x"] returns "x".
 * Given the array [] returns "". */
export function arrayToSentence(
  words: string[],
  {
    lastSeparator = " and ",
    separator = ", ",
    defaultValue = "",
  }: TArrayToSentenceConfig = {},
): string {
  if (words.length < 1) {
    return defaultValue;
  }
  if (words.length === 1) {
    return words[0];
  }
  const lastWord = words.at(-1);
  const theRest = words.slice(0, -1);

  return [ theRest.join(separator), lastWord ].join(lastSeparator);
}

export function arrayToPronoun<
  GENDER extends TArrayToPronounHandledGenders,
  BOY extends string,
  GIRL extends string,
  NEUTRAL extends string,
  INPUT,
>(
  inputWithGender: INPUT[],
  boy: BOY,
  girl: GIRL,
  neutral: NEUTRAL,
  genderGetter: (getFrom: INPUT) => GENDER,
): BOY | GIRL | NEUTRAL {
  if (inputWithGender.length !== 1) {
    return neutral;
  }

  const singleInput = inputWithGender[0];
  const gender = genderGetter(singleInput);

  switch (gender) {
    case "MALE":
    case "BOY":
      return boy;
    case "FEMALE":
    case "GIRL":
      return girl;
    case "UNKNOWN":
    default:
      return neutral;
  }
}
